import React, { useState } from "react";
import "./Contact.css";
import bannerImg from "./img/what (1).jpg"; // 👉 add your banner image in src folder

const Contact = () => {
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    phone: "",
    query: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert(`Thank you, ${formData.fullName}! Your query has been submitted.`);
    setFormData({ fullName: "", email: "", phone: "", query: "" });
  };

  return (
    <div className="contact-page">
      {/* Banner Section */}
      <div className="contact-banner">
        <div className="contact-banner-text">
          <h1>Get in touch</h1>
          <p>
            Want to get in touch? We’d love to hear from you. Here’s how you can
            reach us...
          </p>
        </div>
        <div className="contact-banner-img">
          <img src={bannerImg} alt="Contact Support" />
        </div>
      </div>

      {/* Info + Form */}
      <div className="contact-container">
        {/* Left Info Section */}
        <div className="contact-info">
          <div className="info-block">
            <h3>📧 Office Email</h3>
            <p>edutechmasteracademy@gmail.com</p>
          </div>
          <div className="info-block">
            <h3>📞 Office Phone</h3>
            <p>+91 821-088-9140 | +91 620-757-2550</p>
          </div>
          <div className="info-block">
            <h3>📍 Office Address</h3>
            <p>
              1st Floor, Beside Khel Parisar Gate, Front of Gaya College, <br />
              Gaya College More, Gaya, Bihar - 823004
            </p>
          </div>
        </div>

        {/* Right Form Section */}
        <div className="contact-form">
          <h2>Contact Us</h2>
          <form onSubmit={handleSubmit}>
            <input
              type="text"
              name="fullName"
              placeholder="Full Name"
              value={formData.fullName}
              onChange={handleChange}
              required
            />
            <input
              type="email"
              name="email"
              placeholder="Email Address"
              value={formData.email}
              onChange={handleChange}
              required
            />
            <input
              type="tel"
              name="phone"
              placeholder="Phone Number"
              value={formData.phone}
              onChange={handleChange}
              required
            />
            <textarea
              name="query"
              placeholder="Your Query"
              rows="5"
              value={formData.query}
              onChange={handleChange}
              required
            ></textarea>
            <button type="submit">Send</button>
          </form>
        </div>
      </div>

      {/* Map full width */}
      <div className="map-container">
        <iframe
          title="Edu-Tech Master Academy Map"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d291.84691114990517!2d84.98441494295703!3d24.78103225855815!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39f32b0054d036fb%3A0x26b6062a81f467e7!2sEDU%20-%20TECH%20MASTER%20ACADEMY!5e0!3m2!1sen!2sin!4v1757043919745!5m2!1sen!2sin"
          width="100%"
          height="400"
          style={{ border: 0, borderRadius: "12px" }}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>
    </div>
  );
};

export default Contact;
